import React, { useEffect, useState } from 'react';
import './SettingsStyle.css';
import { useNavigate } from 'react-router-dom';
import { emSettingsMail } from '../model/emSettingsMail';
import { emSettingsHashTag } from '../model/emSettingsHashTag';
import { AiFillDelete} from "react-icons/ai";

interface Props{
    loggedState: number;
    loggedID: String;
}

const Settings = ({loggedState,loggedID}:Props) => {
  const [emSettingsMail,setEmSettingsMail] = useState<emSettingsMail[]>([]);  
  const [emSettingsHashTag,setEmSettingsHashTag] = useState<emSettingsHashTag[]>([]);  

    useEffect(() => {
        ReadSettingsMail(loggedID)
        ReadSettingsHash(loggedID)
      }, []);

      const deleteEmail =  async (ID:number) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/DeleteSettingsMail.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ID,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            if(data.status === 'success'){
              alert("E-Mail gelöscht");
              ReadSettingsMail(loggedID)
            }
            else{
              alert("E-Mail konnte gelöscht werden werden");
            }
              
          } else {
            const data = await response.json();
            console.error('Fehler beim lesen des Einsatz:', response.statusText);
            alert("E-Mail konnte nicht aktualisiert werden");
          }
        } catch (error) {
          console.error('Fehler beim Request:', error);
        }   
      };

      const deleteHash =  async (ID:number) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/DeleteSettingsHashTag.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              ID,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            if(data.status === 'success'){
              alert("E-Mail gelöscht");
              ReadSettingsHash(loggedID)
            }
            else{
              alert("E-Mail konnte gelöscht werden werden");
            }
              
          } else {
            const data = await response.json();
            console.error('Fehler beim lesen des Einsatz:', response.statusText);
            alert("E-Mail konnte nicht aktualisiert werden");
          }
        } catch (error) {
          console.error('Fehler beim Request:', error);
        }   
      };

        const ReadSettingsMail = async (loggedID:String) => {
          try {
            const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadSettingsMail.php', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
              },
              body: JSON.stringify({
                loggedID,
              }),
            });
      
            if (response.ok) {
              const data = await response.json();
              // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
              //console.log('Cars vorhanden:', data);
              setEmSettingsMail(data);
            } else {
              const data = await response.json();
              console.error('Fehler beim lesen der Cars:', response.statusText);
            }
          } catch (error) {
            console.error('Fehler beim Request:', error);
          }
      };

      const ReadSettingsHash = async (loggedID:String) => {
        try {
          const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/ReadSettingsHashTag.php', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({
              loggedID,
            }),
          });
    
          if (response.ok) {
            const data = await response.json();
            // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
            //console.log('Hash vorhanden:', data);
            setEmSettingsHashTag(data);
          } else {
            const data = await response.json();
            console.error('Fehler beim lesen der Cars:', response.statusText);
          }
        } catch (error) {
          console.error('Fehler beim Request:', error);
        }
    };


const mailAdd = async (loggedID:String) => {
  try {
    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/AddSettingsMail.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        loggedID,
      }),
    });
        
    if (response.ok) {
      const data = await response.json();
      if(data.status === 'success'){
        alert("E-Mail Adresse wurde hinzugefügt");
        ReadSettingsMail(loggedID)
      }
      else{
        alert("E-Mail Adresse konnte nicht hinzugefügt werden");
      }
                  
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("E-Mail Adresse konnte nicht hinzugefügt werden");
      }
  } catch (error) {
    console.error('Fehler beim Request:', error);
  }   
};    

const hashAdd = async (loggedID:String) => {
  try {
    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/AddSettingsHashTag.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        loggedID,
      }),
    });
        
    if (response.ok) {
      const data = await response.json();
      if(data.status === 'success'){
        alert("HashTag Adresse wurde hinzugefügt");
        ReadSettingsHash(loggedID)
      }
      else{
        alert("HashTag Adresse konnte nicht hinzugefügt werden");
      }
                  
      } else {
        const data = await response.json();
        console.error('Fehler beim lesen des Einsatz:', response.statusText);
        alert("HashTag Adresse konnte nicht hinzugefügt werden");
      }
  } catch (error) {
    console.error('Fehler beim Request:', error);
  }   
};    

const updateMail = (id:number, field:string, value:string) => {
  setEmSettingsMail((prevSettMail) =>
    prevSettMail.map((mail) =>
      mail.ID === id
        ? { ...mail, [field]: value } // Update das Feld (activeMember oder agt)
        : mail
    )
  );
};

const updateHash = (id:number, field:string, value:string) => {
  setEmSettingsHashTag((prevSettHash) =>
    prevSettHash.map((hash) =>
      hash.ID === id
        ? { ...hash, [field]: value } // Update das Feld (activeMember oder agt)
        : hash
    )
  );
};

const handleMailChange = async (ID:String, value:String) => {
  const column = 'mailAdress'
  try {
    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateSettingsMail.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        //Einsatz => em_Einsätze 
        ID,
        column,
        value,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
      if(data.status === 'success'){
        ReadSettingsMail(loggedID);
      }
      else{
        alert("E-Mail konnte nicht aktualisiert werden");
      }
        
    } else {
      const data = await response.json();
      alert("E-Mail konnte nicht aktualisiert werden");
    }
  } catch (error) {
    console.error('Fehler beim Request:', error);
  }   
};

const handleHashChange = async (ID:String, value:String) => {
  const column = 'hashTag'
  try {
    const response = await fetch('https://ff-schwebda.de/RescueOfficer/Server/UpdateSettingsHashTag.php', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        //Einsatz => em_Einsätze 
        ID,
        column,
        value,
      }),
    });

    if (response.ok) {
      const data = await response.json();
      // Hier kannst du die Antwort des Servers verarbeiten, z. B. Token speichern.
      if(data.status === 'success'){
        ReadSettingsHash(loggedID);
      }
      else{
        alert("HashTag konnte nicht aktualisiert werden");
      }
        
    } else {
      const data = await response.json();
      alert("HashTag konnte nicht aktualisiert werden");
    }
  } catch (error) {
    console.error('Fehler beim Request:', error);
  }   
};

const AddMail = () => {
  mailAdd(loggedID)
  
};

const AddHash = () => {
  hashAdd(loggedID)
  
};

//onChange={(e) => {}}

        return (
            <div className="container">
              <h1>Einstellungen</h1>
              

              <h2>E-Mail Adressen für Einsatzbereicht</h2>
              <p>Die hier angeben E-Mail Adressen erhalten, den Einsatzbericht per E-Mail.</p>
              <table className="table">
              <thead className="table-header">
              <tr>
                <th className="col-1_mail">E-Mail Adresse</th>
                <th className="col-2_mail">
                  <button className="settings-button" onClick={AddMail}>Hinzufügen</button>
                </th>
              </tr>
            </thead>
            <tbody>
              {emSettingsMail.map((row) => (
                <tr key={row.ID}>
                    <td className="col-1_mail">
                      <input
                        type="text"
                        value={row.mailAdress}
                        onChange={(e) => updateMail(row.ID,'mailAdress', e.target.value)}
                        onBlur={(e) => handleMailChange(String(row.ID), String(e.target.value))} // Aktualisiere den Namen
                      />
                    </td>
                    <td className="col-2_mail">
                      <span className='icon' onClick={()=> deleteEmail(row.ID)}>
                          <AiFillDelete></AiFillDelete>
                      </span>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>

          <h2>HashTags für Einsatzbericht</h2>
          <p>Diese HashTags werden an das Ende des Einsatzberichtes für SocialMedia gehangen.</p>
          <p><strong>Achtung!</strong> Es ist nicht notwendig, # vor den Texten einzufügen. Diese werden später automatisch generiert!</p>
          <table className="table">
              <thead className="table-header">
              <tr>
                <th className="col-1_hash">HashTag</th>
                <th className="col-2_hash">
                  <button className="settings-button" onClick={AddHash}>Hinzufügen</button>
                </th>
              </tr>
            </thead>
            <tbody>
              {emSettingsHashTag.map((row) => (
                <tr key={row.ID}>
                    <td className="col-1_hash">
                      <input
                        type="text"
                        value={row.hashTag}
                        onChange={(e) => updateHash(row.ID,'hashTag', e.target.value)}
                        onBlur={(e) => handleHashChange(String(row.ID), String(e.target.value))} // Aktualisiere den Namen
                      />
                    </td>
                    <td className="col-2_hash">
                      <span className='icon' onClick={()=> deleteHash(row.ID)}>
                          <AiFillDelete></AiFillDelete>
                      </span>
                    </td>
                </tr>
              ))}
            </tbody>
          </table>
            </div>
          );
        }
        
        export default Settings;